import React from 'react';
import { LoadableComponent } from 'react-loadable';

import { ConfigBlockState, IRenderProps, IWidgetBlockComponent, WidgetBlock, WidgetBlocksState } from '../WidgetBlocks/types/IWidgetBlock';
import {
    initializeWidget,
    loadingWidgetData,
    loadingWidgetTemplate,
    widgetDataLoaded,
    widgetTemplateLoaded,
    setReportTime,
    setReportSite,
} from './widgetblock/actions';
import WidgetBlockActionReducer, { Actions } from './WidgetBlockReducer';

const applyMultipleActions = (startingState: WidgetBlocksState | undefined, ...actions: Actions[]) => {
    const reducer = WidgetBlockActionReducer([]);

    return actions.reduce((previous, current) => reducer(previous, current), startingState);
};

const WidgetBlockToViewBlockHoC =
    (
        widgetBlockReducer: WidgetBlock['reducer'],
        WidgetBlockComponent: (React.ComponentType<IWidgetBlockComponent> & LoadableComponent) | React.ComponentType<IWidgetBlockComponent>
    ) =>
    ({ viewblockState, datasets, reportTime, site }: IRenderProps<ConfigBlockState>) => {
        const widgetId = WidgetBlockComponent.name;
        const instanceId = '1';

        const state = applyMultipleActions(
            undefined,
            initializeWidget(widgetId, instanceId, widgetBlockReducer),
            loadingWidgetTemplate(widgetId, instanceId),
            loadingWidgetData(widgetId, instanceId),
            widgetTemplateLoaded(widgetId, instanceId, viewblockState),
            widgetDataLoaded(widgetId, instanceId, datasets),
            setReportTime(widgetId, instanceId, reportTime),
            setReportSite(widgetId, instanceId, site)
        );

        // TODO: Clean-up, potentially remove this class and return the WidgetBlockComponent straight off.
        // This component isn't doing much, but is potentially allowing us to pass props. Need to test.
        const WidgetBlockToViewBlock = (props: React.ComponentProps<typeof WidgetBlockComponent>) => {
            const widgetModel = state!.widgetModels.get(widgetId)?.get(instanceId);

            return <WidgetBlockComponent {...props} widgetModel={widgetModel} />;
        };

        return <WidgetBlockToViewBlock />;
    };

export default WidgetBlockToViewBlockHoC;
